import {createContext} from 'react'
import {OrderContext} from './_context'

export const OrderProvider = OrderContext.Provider
